import { Props_SnippetContent } from './Content.props'
import { Legacy_CompileMarkdown } from '@ClientBase/React/ReactSnippetMDCompiler'

const SnippetContent = (props: Props_SnippetContent) => {
    const { heading, repeatable_link, paragraph } = props
    
    const classHeadingVisibility: string = heading.visibility?.value ? `snippet-content__heading--${heading.visibility.value}` : ''

    return (
        <section className="snippet-content">
            <div className="snippet-content__container">
                <h2 className={`snippet-content__heading ${classHeadingVisibility}`}>{heading?.content?.value}</h2>
                <div className="snippet-content__container-content">
                    { paragraph.content.value && Legacy_CompileMarkdown(paragraph?.content?.value) }
                </div>
                <div className="snippet-content__container-links">
                    { repeatable_link.map((link, index) => (
                        link.linkContent?.value && link.linkUrl?.value && (
                            <a
                                key={index}
                                className="snippet-content__link"
                                href={link.linkUrl?.value}
                                target={link.linkTarget?.value === 'true' ? '_blank' : '_self'}
                                rel={link.linkTarget?.value === 'true' ? 'noopener noreferrer' : ''}
                            >
                                {link.linkContent?.value}
                            </a>
                        )
                    ))}
                </div>
            </div>
        </section>
    )}

export default SnippetContent
